export const refreshToken = (_this) => {
    let openId = sessionStorage.getItem('openId')
    let token = sessionStorage.getItem("token")
    return new Promise((resolve, reject) => {
        _this.$http({
            url: '/client/liveUser/refreshToken',
            method: 'post',
            headers: {
                'authorization': token
            },
            params: { openId },
        }).then(({ data }) => {
            if (data && data.code === 0) {
                if (data.data) {
                    sessionStorage.setItem('token', data.data)
                    getUser(_this, data.data).then(res => {
                        if (res.data) {
                            resolve(res)
                        } else {
                            reject(res)
                        }
                    })
                }
            }
        })
    })
}

const getUser = (_this, token) => {
    return new Promise((resolve, reject) => {
        _this.$http({
            url: '/client/liveUser/getUserInfo',
            method: 'get',
            headers: {
                'authorization': token,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(({ data }) => {
            if (data && data.code === 0) {
                let userInfo = data.data
                sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
                sessionStorage.setItem('userId', userInfo.userId)
                sessionStorage.setItem('openId', userInfo.openId)
                resolve(data)
            } else { reject(data) }

        })
    })
}